import React from 'react'
import { PMPBodySectionItems } from './styledComponent'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import {
  getCasedHeadingTextBasedOnStyleOverrides,
  getValidDiagnosisArrayForPrescription,
  preparePrescriptionDiagnosisLine,
} from './util'

export default function PrintableDiagnosis({
  diagnosisRef,
  debug,
  selectedDiagnosis,
  debugHighlightStates,
  styleOverrides,
}) {
  const diagnosisToShow = getValidDiagnosisArrayForPrescription(selectedDiagnosis)

  return (
    <PMPBodySectionItems
      ref={diagnosisRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.diagnosis?.color}
      debugHighlight={debugHighlightStates?.diagnosis}
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Diagnosis',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
        className="d-flex align-items-center gap-1 flex-wrap"
      >
        {diagnosisToShow.map((diagnosisItem, idx) => (
          <div style={{ paddingRight: '6px' }} key={idx}>
            {preparePrescriptionDiagnosisLine(diagnosisItem)}{' '}
            {diagnosisToShow?.length - 1 !== idx && ', '}
          </div>
        ))}
      </div>
    </PMPBodySectionItems>
  )
}
